import { AgentsHumanizerIcon, Icon, type IconProps } from '@grammarly/design-system'

type HumanizerAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const HumanizerAgentIcon = ({ size, accessibilityLabel }: HumanizerAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsHumanizerIcon}
      accessibilityLabel={accessibilityLabel ?? 'Humanizer Agent'}
    />
  )
}
